var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cool-select',{attrs:{"list":_vm.counterparties,"option-value":"id","option-text":"value","isDisabled":_vm.isReadOnlyMode,"placeholder":_vm.$t('CONTENT.choose')},model:{value:(_vm.currentCounterpartyId),callback:function ($$v) {_vm.currentCounterpartyId=$$v},expression:"currentCounterpartyId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }